import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_ESUS, useChartsData } from '../../../Common/Filters/useChartsData';


export const ResultsChartsDataContext = createContext();

const ResultsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.REGISTERS_RESULTS,
            url: 'governanceroom/esus/registers/results'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            register_type: filters.register_type_results.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              annualEvolutionRegisters: data?.annualEvolutionRegisters ?? [],
              monthlyEvolutionRegistersPercentage:
                  data?.monthlyEvolutionRegistersPercentage ?? [],
              monthlyEvolutionRelationIndividualAndhouseHold:
                  data?.monthlyEvolutionRelationIndividualAndhouseHold ?? [],
              tableHouseHoldAndIndividualRegister:
                  data?.tableHouseHoldAndIndividualRegister ?? []
          }
        : {
              annualEvolutionRegisters: [],
              monthlyEvolutionRegistersPercentage: [],
              monthlyEvolutionRelationIndividualAndhouseHold: [],
              tableHouseHoldAndIndividualRegister: []
          };

    return (
        <ResultsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ResultsChartsDataContext.Provider>
    );
};

export default ResultsChartsDataProvider;
